import { TranslatedText } from "@/components/common/text";

export const LoadModelDetailsRow = ({ label, children }) => {
    return (
        <div className="flex items-center justify-between text-sm/[22px] text-cm-text-primary">
            <div>
                <TranslatedText>{label}</TranslatedText>
            </div>
            <div className="font-medium">{children}</div>
        </div>
    );
};
